import { delay } from 'lodash';
import { Colors } from '../consts/Colors.js';
import { tags } from '../consts/Tags.js';
import TxtBtn from './TxtBtn.js';

export default class EndB3Item extends Phaser.GameObjects.Container {
    constructor(scene, x, y, data) {
        super(scene, x, y, []);
        scene.add.existing(this);
        this.scene = scene;

        this.w = 515;
        this.h = 581;
        this.titleCtnt = data.title.toUpperCase();
        this.startingY = data.startingY;
        this.bulletSpace = data.bulletSpace;
        this.allBullets = data.bullets;
        this.lastLine = data.lastLine;

        this.allElements = []


        this.rect = this.scene.add.rexRoundRectangle(0, 0, this.w, this.h, 15, Colors.Elmt.lightBlue)
        this.add(this.rect);
        this.strocks = this.scene.add.rexRoundRectangle(-10, -10, this.w, this.h, 15, Colors.Elmt.lightBlue, 0)
        this.strocks.setStrokeStyle(3, Colors.Elmt.Black)
        this.add(this.strocks);
        // this.allElements.push([this.rect, this.strocks]);

        this.title = this.scene.add.rexTagText(0, -this.h / 2 + 40, this.titleCtnt, {
            fontSize: "30px",
            fontFamily: "DKButterfly",
            align: 'center',
            color: Colors.Text.Black,
            backgroundColor: "transparent",
            wordWrap: { width: this.w - 40 },
            tags: tags
        }).setOrigin(0.5, 0);
        this.add(this.title);
        this.allElements.push(this.title);

        for (let i = 0; i < this.allBullets.length; i++) {
            const element = this.allBullets[i];
            let illu = this.scene.add.image(-this.w / 2 + 80, -this.h / 2 + this.startingY + this.bulletSpace * i, element.illu).setOrigin(0.5, 0.5);
            this.add(illu);
            let content = this.scene.add.rexTagText(-this.w / 2 + 170, -this.h / 2 + this.startingY + this.bulletSpace * i, element.content, {
                fontSize: "24px",
                fontFamily: "CenturyGothic",
                align: 'left',
                color: Colors.Text.Black,
                backgroundColor: "transparent",
                wordWrap: { width: 300 },
                tags: tags
            }).setOrigin(0, 0.5);
            this.add(content);
            this.allElements.push([illu, content]);


        }

        // let endArrow = this.scene.add.image(-this.w / 2 + 80, -this.h / 2 + 490, "b3EndArrow").setOrigin(0.5, 0.5);
        // this.add(endArrow);
        // let content = this.scene.add.rexTagText(-this.w / 2 + 120, -this.h / 2 + 490, this.lastLine, {
        //     fontSize: "24px",
        //     fontFamily: "CenturyGothic",
        //     align: 'left',
        //     color: Colors.Text.Black,
        //     backgroundColor: "transparent",
        //     wordWrap: { width: 370 },
        //     tags: tags
        // }).setOrigin(0, 0.5);
        // this.add(content);
        // this.allElements.push([endArrow, content]);

        this.allElements.forEach(element => {
            console.log("Element alpha set to 1: ", element.length);
            if (element.length != undefined) {
                element.forEach(el => el.setAlpha(0));
            } else {
                element.setAlpha(0)
            }
        });
    }

    launchContent(){
         this.allElements.forEach((el, index) => {
            this.scene.time.addEvent({
                delay: index * 100,
                callback: () => {
                    console.log("el alpha set to 1: ", el);
                    if (el.length != undefined) {
                        el.forEach(el => el.setAlpha(1));
                    } else {
                        el.setAlpha(1)
                        this.scene.playSound('pop');
                    }
                }
            })
        })
    }
}